module.exports = __webpack_public_path__ + "static/media/Trophy.0fcfdb02.png";